import React, { useContext, useEffect, useState } from 'react'

// import { useSuperAdmin } from '../../hooks/SuperAdminConfiguration/useSuperAdmin'
import { formatDate, ROUTES } from '../../shared/constants'
import { useHistory } from 'react-router'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useDownload } from '../../hooks/Download/useDownload'
import { SuperAdminContext } from '../../context api/SuperAdmin/SuperAdminContext'
import { useSuperAdmin } from '../../hooks/SuperAdmin/useSuperAdmin'

export default function SuperAdmins() {
  const { getAllSuperAdmin, deleteManySuperAdmin, loading, paginate, updateSuperAdmin } = useSuperAdmin()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { superAdmins } = useContext(SuperAdminContext)
  //console.log('superAdmins : ', superAdmins)
  const history = useHistory()

  const [searchQuery, setSearchQuery] = useState('')
  const filterSuperAdmin = superAdmins
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllSuperAdmin({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData('GET_ALL_SUPERADMINS')
  }, [])

  const handleChange = (event, value) => {
    setPage(value)
  }

  const handleSwitchChange = (item) => updateSuperAdmin({ ...item, active: !item.active, companyId: item._id })

  let tableBody = []

  if (!loading && filterSuperAdmin.length > 0) {
    tableBody = filterSuperAdmin.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id },
        { value: item.superAdminCode },
        { value: `${item.firstName} ${item.lastName}` },
        { value: item.phoneNumber },
        { value: item.email },
        { value: formatDate(item.createdAt) },
        { type: 'STATUS', ...item },
        { type: 'INFO', onClick: () => history.push(`/view-superAdmin/${item._id}`) },
      ]
    })
  }

  const layoutProps = {
    heading: 'Manage SuperAdmins',
    url: ROUTES.ADD_SUPERADMIN,
    editUrl: `/edit-superadmin/`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    tempHeaderData: [],
    filename: 'superAdmins',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
  }

  return (
    <CustomTableLayout
      tableHeadings={['SuperAdmin Code', 'Name', 'phone number', 'email', 'Created Date', 'Status', 'Info']}
      loading={loading}
      tableBody={tableBody}
      handleSwitchChange={handleSwitchChange}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => deleteManySuperAdmin({ companyId: val }, setSelected)}
    />
  )
}
